import { Link } from "react-router-dom";
import logo from "@/assets/logo-white-small.png";
import { INDIAMART_URL } from "@/components/IndiaMart";

const Footer = () => (
  <footer className="bg-primary py-10 md:py-12" role="contentinfo">
    <div className="container mx-auto px-4">
      <div className="flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-3">
          <img src={logo} alt="Taher Steel Tube Co. logo" loading="lazy" className="h-32 w-auto object-contain shrink-0" width={160} height={160} />
          <span className="font-display text-base md:text-lg font-bold text-primary-foreground tracking-wide text-center">
            TAHER STEEL TUBE CO.
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
          <span className="font-body text-xs text-primary-foreground/80">We deliver to:</span>
          <Link to="/suppliers" className="font-body text-xs text-primary-foreground/60 hover:text-accent transition-colors">All Locations</Link>
          <Link to="/locations/tamil-nadu" className="font-body text-xs text-primary-foreground/60 hover:text-accent transition-colors">Tamil Nadu</Link>
          <Link to="/locations/kerala" className="font-body text-xs text-primary-foreground/60 hover:text-accent transition-colors">Kerala</Link>
          <Link to="/locations/karnataka" className="font-body text-xs text-primary-foreground/60 hover:text-accent transition-colors">Karnataka</Link>
        </div>
        <p className="font-body text-xs text-primary-foreground/80 text-center">
          © {new Date().getFullYear()} Taher Steel Tube Co. All rights reserved.
          | Quality Steel. Reliable Supply.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a href="/blog" className="font-body text-xs text-primary-foreground/80 hover:text-accent transition-colors">Blog</a>
          <Link to="/steel-price-today" className="font-body text-xs text-primary-foreground/80 hover:text-accent transition-colors">Steel Price Today</Link>
          <a href="/careers" className="font-body text-xs text-primary-foreground/80 hover:text-accent transition-colors">Careers</a>
          <a href={INDIAMART_URL} target="_blank" rel="noopener" className="font-body text-xs text-primary-foreground/80 hover:text-accent transition-colors">IndiaMART</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;